import React from "react";

export function UserRolesBulkUpload() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-800">Bulk Upload</h2>
        <p className="text-sm text-muted-foreground">
          Bulk upload content will be added here.
        </p>
      </div>
    </div>
  );
}
